export default __webpack_public_path__ + "static/mockupsProPagePlanner-4137df8e23914e04e35c074119383abb.jpg";